import { Outlet } from '@tanstack/react-router';

/**
 * header/footer/container なしのシンプルなレイアウト
 */
export const SimpleRouteLayout = () => {
  return <Outlet />;
};
